import type { ReactNode } from 'react';

type SectionCardProps = {
  title?: string;
  subtitle?: string;
  /** Optional control rendered on the right of the title row (e.g. primary action). */
  headerRight?: ReactNode;
  tone?: 'default' | 'accent' | 'muted';
  children: ReactNode;
  className?: string;
};

const toneClass: Record<NonNullable<SectionCardProps['tone']>, string> = {
  default: 'border-border bg-surface',
  accent: 'border-primary/20 bg-primary/5',
  muted: 'border-border bg-canvas',
};

export function SectionCard({
  title,
  subtitle,
  headerRight,
  tone = 'default',
  children,
  className = '',
}: SectionCardProps) {
  const hasHeader = Boolean(title || subtitle || headerRight);

  return (
    <section className={`rounded-2xl border p-5 shadow-card ${toneClass[tone]} ${className}`}>
      {hasHeader ? (
        <div className="flex items-start gap-3">
          <div className="min-w-0 flex-1">
            {title ? <h2 className="text-lg font-semibold text-ink">{title}</h2> : null}
            {subtitle ? <p className="mt-1 text-sm text-muted">{subtitle}</p> : null}
          </div>
          {headerRight ? <div className="shrink-0">{headerRight}</div> : null}
        </div>
      ) : null}
      <div className={hasHeader ? 'mt-4 space-y-3' : 'space-y-3'}>{children}</div>
    </section>
  );
}
